import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { Grid } from "@mui/material";
import { LabReportHeader } from "./components/LabReportHeader";
import { TableChemistry } from "@/pages/laboratory/data-entry/components/tables/chemistries/TableChemistry";

export const LabReport = () => {
  const {
    state: { heat },
  } = useHeatReportContext();

  return (
    <>
      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <LabReportHeader />
        </Grid>
      </Grid>

      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <TableChemistry
            key={`lab-heat-report${heat?.HeatId}`}
            assetId={null}
            heatId={heat?.HeatId ?? null}
          />
        </Grid>
      </Grid>
    </>
  );
};
